import { useMutation } from '@tanstack/react-query';
import { useAppDispatch, useAppSelector } from '../useAppStore';
import { getAuthenticateUser } from '../../store/authenticate/selectors';
import { StorageController } from '../../services/storage.api';
import { TSetAvatarReq } from '../../types/requests';
import { TAxiosError, TSetAvatarRes } from '../../types/responses';
import { authActions } from '../../store/authenticate/slice';
import { useError } from '../useCommon';

export function useAvatarFileAPI() {
  const authenticateUser = useAppSelector(getAuthenticateUser);
  const dispatch = useAppDispatch();
  const { handleReqError } = useError();

  const setAvatarFileApi = (avatarFile: TSetAvatarReq['b64I']) => {
    const { personnel } = authenticateUser;

    const data = {
      shopName: personnel.shopName,
      email: personnel.email,
      b64I: avatarFile,
    };

    return StorageController().setAvatarFile<TSetAvatarRes>(data);
  };

  return useMutation(setAvatarFileApi, {
    onSuccess: (rsp, variables) => {
      if (rsp?.success && 'resultUrl' in rsp) {
        const parsedUrl = new URL(rsp.resultUrl);
        const pathSegments = parsedUrl.pathname.split('/');
        const avatarFile = pathSegments[pathSegments.length - 1];

        dispatch(authActions.setAuthenticateUser({
          ...authenticateUser,
          personnel: {
            ...authenticateUser.personnel,
            avatarFile,
          },
        }));
      } else if (rsp?.error && rsp.error?.response?.status) {
        handleReqError(rsp.error, variables);
      } else if ('msg' in rsp) {
        console.error(`ERROR! set avatar failed! ${rsp.msg}`);
      }
    },
    onError: (error: TAxiosError) => {
      console.error(`ERROR! set avatar request threw an Exception! ${error}`);
    },
  });
}
